import React from 'react'
import { connect } from 'react-redux';
import {toggleProp} from '../../fm/reducers/admin'
import {userAccess} from '../../fm/lib/auth'

const LibraryLink = ({libraryView, toggleLibraryView}) => {
	if(!userAccess('view_library') || libraryView) return null
	
	return (
	<a className='library-link' onClick={toggleLibraryView} title='Biblioteca'>
		<i className='fa fa-book fa-2x'></i>
	</a>
)}
export default connect(state => ({
	isAuthenticated: state.auth.isAuthenticated,
	libraryView: state.admin.props.library
}), 
dispatch => ({
	toggleLibraryView: () => dispatch(toggleProp('library')),
}))(LibraryLink)



// WEBPACK FOOTER //
// ./src/components/auth/LibraryLink.js